import {
  AccessibilityRounded,
  AccountCircleRounded,
  BarChartRounded,
  EmojiPeopleRounded,
  PaymentRounded,
  ReceiptRounded,
  RecentActorsRounded,
  TuneRounded,
} from "@mui/icons-material";
import { NavItem } from "../../layout";
import { useTranslation } from "react-i18next";

const NavMenu = () => {
  const { t } = useTranslation();
  return (
    <div>
      <NavItem
        title={t("Dashboard")}
        path="dashboard"
        icon={<BarChartRounded className="fs-22" />}
      />

      <NavItem
        title={t("Inquiry")}
        icon={<RecentActorsRounded />}
        child={[
          {
            title: t("InquiryList"),
            path: "inquiries",
          },
          {
            title: t("AddInquiry"),
            path: "inquiry_form",
          },
        ]}
      />

      <NavItem
        title={t("Membership")}
        icon={<AccountCircleRounded className="fs-22" />}
        child={[
          {
            title: t("MemberList"),
            path: "members",
          },
          {
            title: t("AddMember"),
            path: "member_form",
          },
          {
            title: t("FreezeList"),
            path: "freeze_members",
          },
          {
            title: t("AddFreeze"),
            path: "freeze_form",
          },
        ]}
      />
      <NavItem
        title={t("Measurement")}
        icon={<AccessibilityRounded className="fs-22" />}
        child={[
          {
            title: t("MeasurementList"),
            path: "measurements",
          },
          {
            title: t("AddMeasurement"),
            path: "measurement_form",
          },
        ]}
      />
      <NavItem
        title={t("Payment")}
        icon={<PaymentRounded className="fs-22" />}
        child={[
          {
            title: t("PaymentList"),
            path: "payments",
          },
          {
            title: t("AddPayment"),
            path: "payment_form",
          },
        ]}
      />
      <NavItem
        title={t("Invoice")}
        icon={<ReceiptRounded className="fs-22" />}
        child={[
          {
            title: t("InvoiceList"),
            path: "invoices",
          },
          {
            title: t("AddInvoice"),
            path: "invoice_form",
          },
        ]}
      />
      <NavItem
        title={t("Attendance")}
        path="attendance"
        icon={<EmojiPeopleRounded className="fs-22" />}
      />

      <NavItem
        title={t("Master")}
        icon={<TuneRounded className="fs-22" />}
        child={[
          {
            title: t("UserList"),
            path: "users",
          },
          {
            title: t("BranchList"),
            path: "branches",
          },
          {
            title: t("DefaultBranch"),
            path: "default_branch",
          },
          {
            title: t("CityList"),
            path: "cities",
          },
          {
            title: t("Organization"),
            path: "organization",
          },
          {
            title: t("SubscriptionTypes"),
            path: "subscription_types",
          },
          {
            title: t("SubscriptionPlans"),
            path: "subscription_plans",
          },
          {
            title: t("InquirySources"),
            path: "inquiry_sources",
          },
          {
            title: t("FollowUpTypes"),
            path: "Follow_up_types",
          },
          {
            title: t("MemberStatus"),
            path: "member_status",
          },
        ]}
      />
    </div>
  );
};

export default NavMenu;
